var C = Object.defineProperty;
var F = (n, t, e) => t in n ? C(n, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[t] = e;
var l = (n, t, e) => (F(n, typeof t != "symbol" ? t + "" : t, e), e), U = (n, t, e) => {
  if (!t.has(n))
    throw TypeError("Cannot " + e);
};
var i = (n, t, e) => (U(n, t, "read from private field"), e ? e.call(n) : t.get(n)), u = (n, t, e) => {
  if (t.has(n))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(n) : t.set(n, e);
}, E = (n, t, e, o) => (U(n, t, "write to private field"), o ? o.call(n, e) : t.set(n, e), e);
var v = (n, t, e) => (U(n, t, "access private method"), e);
class L extends Error {
  constructor() {
    super(...arguments);
    l(this, "name", "AuthenticationError");
    l(this, "message", "authentication fail");
  }
}
class R extends Error {
  constructor() {
    super(...arguments);
    l(this, "name", "ServiceNotFoundError");
    l(this, "message", "service does not exist");
  }
}
class M extends Error {
  constructor() {
    super(...arguments);
    l(this, "name", "HostNotAllowedError");
    l(this, "message", "host is not allowed");
  }
}
var p, h, $, m, I, f, x, A, H;
const c = class {
  constructor(t, e) {
    u(this, f);
    u(this, A);
    u(this, h, void 0);
    u(this, $, void 0);
    E(this, h, t), E(this, $, e);
  }
  static authenticate({ service: t, env: e, lang: o, theme: r, style: s }) {
    var a;
    return v(a = c, m, I).call(a, t, e).authenticate({ lang: o, theme: r, style: s });
  }
  static editMyInfo({ service: t, env: e, lang: o, theme: r, returnPath: s }) {
    var a;
    return v(a = c, m, I).call(a, t, e).editMyInfo({ lang: o, theme: r, returnPath: s });
  }
  static logout({ service: t, env: e, redirectUri: o }) {
    var r;
    return v(r = c, m, I).call(r, t, e).logout(o);
  }
  async authenticate(t) {
    const { lang: e = "ko", theme: o = "light", style: r = { width: 410, height: 680, top: "", left: "" } } = t;
    await v(this, A, H).call(this);
    let s = null;
    const a = r, P = `${i(this, f, x)}/authentication?popup=1&lang=${e}&theme=${o}`;
    Object.entries(a).forEach(([d, w]) => a[d] = w);
    const b = (d, w) => ({ data: g }) => {
      if (g.type === "authentication")
        return window.removeEventListener("message", b(d, w), !1), g.result === "success" ? d() : w(new L()), s == null ? void 0 : s.close();
    };
    return new Promise((d, w) => {
      window.addEventListener("message", b(d, w), !1);
      let { width: g, height: k, top: N, left: S } = a;
      g && (g = `width=${g}`), k && (k = `height=${k}`), N && (N = `top=${N}`), S && (S = `left=${S}`), s = window.open(P, "Authentication", `popup,${g},${k},${N},${S},menubar=no,status=no,titlebar=no`);
    });
  }
  editMyInfo(t) {
    const { lang: e = "ko", theme: o = "light", returnPath: r } = t, s = `${i(this, f, x)}/account/info?lang=${e}&theme=${o}&return_path=${encodeURIComponent(r)}&service=${i(this, h)}`;
    window.location.assign(s);
  }
  logout(t = window.location.origin) {
    const e = `${i(this, f, x)}/logout?redirect_uri=${encodeURIComponent(t)}`;
    window.location.replace(e);
  }
};
let y = c;
p = new WeakMap(), h = new WeakMap(), $ = new WeakMap(), m = new WeakSet(), I = function(t, e) {
  return i(c, p) || E(c, p, new c(t, e)), i(c, p);
}, f = new WeakSet(), x = function() {
  const t = "member.bigpi.co", e = i(this, $).replace(/development|local/, "dev").replace(/production/, "");
  return `https://${e ? `${e}-${t}` : t}`;
}, A = new WeakSet(), H = function() {
  return new Promise((t, e) => i(this, h) ? i(this, $) === "local" || window.location.host.includes(i(this, h).replace(/dakgg/, "dak")) ? t(!0) : e(new M()) : e(new R()));
}, u(y, m), u(y, p, void 0);
export {
  y as Membership
};
